import { Link } from "react-router-dom";
import Grow from "@mui/material/Grow";
import { createPortal } from "react-dom";
import { colorTokens } from "../../../styles/designTokens";

const actionSecondaryActive = colorTokens?.actionSecondaryActive || "#e4e4e4";
const actionSecondaryBase2 = colorTokens?.actionSecondaryBase2 || "#f2f2f2";

function isPathActive(currentPath, targetPath) {
  if (!targetPath) return false;
  if (targetPath === "/") return currentPath === "/";
  return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);
}

function handleHoverEnter(event, active) {
  if (active) return;
  event.currentTarget.style.backgroundColor = actionSecondaryBase2;
}

function handleHoverLeave(event, active) {
  event.currentTarget.style.backgroundColor = active ? actionSecondaryActive : "";
}

export default function NestedOverlay({
  overlay,
  activePath,
  onMouseEnter,
  onMouseLeave,
  onItemClick,
}) {
  if (!overlay) return null;

  return createPortal(
    <Grow
      in={Boolean(overlay?.open)}
      timeout={{ enter: 160, exit: 110 }}
      mountOnEnter
      unmountOnExit
    >
      <div
        className="fixed z-[80]"
        style={{
          top: overlay.anchor.top,
          left: overlay.anchor.left,
          transformOrigin: "top left",
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="min-w-[200px] rounded-2xl border border-slate-100 bg-white shadow-[0_15px_35px_rgba(15,23,42,0.2)] p-3 flex flex-col gap-1">
          {overlay.items?.map((child) => {
            const childActive = child.to && isPathActive(activePath, child.to);
            const ChildComponent = child.to ? Link : "div";
            const childProps = child.to ? { to: child.to, onClick: onItemClick } : {};

            return (
              <ChildComponent
                key={child.to || child.subTitle}
                {...childProps}
                className={`rounded-lg px-3 py-1.5 text-sm transition-colors ${
                  childActive
                    ? "text-slate-900 font-semibold"
                    : "text-slate-500 hover:text-slate-700"
                }`}
                style={childActive ? { backgroundColor: actionSecondaryActive } : undefined}
                onMouseEnter={(e) => handleHoverEnter(e, childActive)}
                onMouseLeave={(e) => handleHoverLeave(e, childActive)}
              >
                {child.subTitle}
              </ChildComponent>
            );
          })}
        </div>
      </div>
    </Grow>,
    document.body
  );
}
